/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the "Elastic License
 * 2.0", the "GNU Affero General Public License v3.0 only", and the "Server Side
 * Public License v 1"; you may not use this file except in compliance with, at
 * your election, the "Elastic License 2.0", the "GNU Affero General Public
 * License v3.0 only", or the "Server Side Public License, v 1".
 */

import React, { Suspense } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
function dynamic(loader) {
  const Component = /*#__PURE__*/React.lazy(loader);
  return /*#__PURE__*/React.forwardRef((props, ref) => ___EmotionJSX(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(Component, {
    ...props,
    ref
  })));
}
export { usePerformanceContext } from './context/use_performance_context';
export { perfomanceMarkers } from './performance_markers';
export { usePageReady } from './context/use_page_ready';
export const PerformanceContextProvider = dynamic(() => import('./context/performance_context'));